import { createSlice } from "@reduxjs/toolkit";

const initialState = {};

const messageSlice = createSlice({
    name: "message",
    initialState,
    reducers: {
        setMessage: (state, action) => {
            return { message: action.payload };
        },
        clearMessage: () => {
            return { message: "" };
        },
        setLanguageDialog: (state, action) => {
            return { showDialog: action.payload }
        }
    },
});

const { reducer, actions } = messageSlice;

export const { setMessage, clearMessage, setLanguageDialog } = actions
export default reducer